import {createSelector} from '@reduxjs/toolkit'
import {RootState} from 'app/rootReducer'
import {AdminState} from './adminSlice'

function getUser(state: RootState): AdminState {
  return state.admin
}

export const selectAdmin = createSelector(getUser, admin => admin)
